import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getName, uploadProfilePic, getProfilePic } from "../Actions";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import { Link, useNavigate } from "react-router-dom";
import AddComment from "./AddComment";
import EditableText from "./EditableText";
import { editForumPost, deleteForumPost, editForumComment, deleteForumComment } from "../utils/forumActions";
import genericProfilePic from "../genericprofilepic.png";
import { useUsers } from "../UserContext";
import { newestFirst, oldestFirst } from "../utils/time";
import { toast } from "react-hot-toast";

function Dashboard(props) {
  const navigate = useNavigate();
  const { users, fetchUsers } = useUsers();
  const [userId, setUserId] = useState("");
  const [greeting, setGreeting] = useState("");
  const [weekGreeting, setWeekGreeting] = useState("");
  const [almostShabbat, setAlmostShabbat] = useState(false);

  const [chapterCommentary, setChapterCommentary] = useState([]);
  const [posts, setPosts] = useState([]);
  const [postComments, setPostComments] = useState([]);

  const [openCommentFor, setOpenCommentFor] = useState(null);
  const [uploading, setUploading] = useState(false);

  const date = new Date();
  const hour = date.getHours();
  const day = date.getDay();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [commSnap, postsSnap, commentsSnap] = await Promise.all([
          getDocs(collection(db, 'commentaries')),
          getDocs(collection(db, 'posts')),
          getDocs(collection(db, 'postComments')),
        ]);
        setChapterCommentary(commSnap.docs.map(d => ({ id: d.id, ...d.data() })).sort(newestFirst));
        setPosts(postsSnap.docs.map(d => ({ id: d.id, ...d.data() })).sort(newestFirst));
        setPostComments(commentsSnap.docs.map(d => ({ id: d.id, ...d.data() })).sort(oldestFirst));
      } catch (err) {
        console.error("Failed to load dashboard posts:", err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    setUserId(localStorage.getItem("user_id"));

    function pickGreeting() {
      if (hour >= 5 && hour < 12) {
        return setGreeting("Good Morning");
      }
      if (hour >= 12 && hour < 17) {
        return setGreeting("Good Afternoon");
      }
      if (hour >= 17 && hour < 22) {
        return setGreeting("Good Evening");
      } else {
        return setGreeting("Night Greetings");
      }
    }

    function shabbat_shavua() {
      if (
        (day < 5 && day > 0) ||
        (day === 5 && hour < 18) ||
        (day === 0 && hour >= 18)
      ) {
        return setWeekGreeting(
          `It's a weekday. May Yahweh fill your week with purpose and peace until you enter His rest on the blessed Sabbath day!`
        );
      }
      if ((day === 5 && hour >= 18) || (day === 6 && hour < 18)) {
        return setWeekGreeting(
          `It's the Sabbath today! Shabbat Shalom! - שבת שלום - or... Sabbath Peace to you!`
        );
      }
      if ((day === 6 && hour >= 18) || (day === 0 && hour < 18)) {
        return setWeekGreeting(
          `A new fresh week has started! Shavua Tov! -  שבוע טוב - or... Have a good week!`
        );
      }
    }

    if (day === 4 || (day === 5 && hour < 18)) {
      setAlmostShabbat(true);
    }

    pickGreeting();
    shabbat_shavua();
  }, [day, hour]);

  const handleUploadPic = async () => {
    const input = document.querySelector('input.upload-img');
    if (!input?.files?.[0]) {
      toast.error("Choose a picture first.");
      return;
    }
    setUploading(true);
    const ok = await props.uploadProfilePic();
    setUploading(false);
    if (ok) {
      input.value = "";
      toast.success("Profile picture updated!");
      fetchUsers();
    } else {
      toast.error("Upload failed. Please try again.");
    }
  };

  const handleGoToWall = () => {
    if (props.first_name && props.last_name) {
      const username = `${props.first_name}${props.last_name}`;
      navigate(`/user/${username}`);
    } else {
      const currentUser = users.find(u => u.id === userId);
      if (currentUser) {
        const username = `${currentUser.first_name}${currentUser.last_name}`;
        navigate(`/user/${username}`);
      }
    }
  };

  const lastCommentary = chapterCommentary.slice(0, 3);
  const filteredPosts = posts.slice(0, 3);

  return (
    <div>
    <div style={{
        backgroundImage: `url(${require('../dashboard-parchment.jpg')})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    }}>
      <br />
      <br />
      <h2 className="h2-greeting">
        {greeting} {props.first_name} {props.last_name}!
      </h2>
      <br />
      <img
          id="profilepic"
          src={props.profile_pic_url || genericProfilePic}
          alt="profile"
      ></img>
      <form>
        <input className="upload-img" type="file" accept="image/*" />
        <br />
        <button
          type="button"
          className="btn submit-pic"
          onClick={handleUploadPic}
          disabled={uploading}
        >
          {uploading ? "Uploading…" : "Submit New Profile Pic"}
        </button>
      </form>
      <br />
      <div className="notification">{weekGreeting}</div>
      <br />
      {almostShabbat ? (
        <div className="yellownotification">It's almost... SHABBAT!!!</div>
      ) : null}
      <br />

      {/* CTA Tiles */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', justifyContent: 'center', padding: '10px 20px 30px' }}>
        <div style={{ background: 'rgba(255,255,255,0.75)', borderRadius: '16px', padding: '20px', width: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <p className="mediumtext" style={{ margin: 0, padding: 0, width: '100%', fontSize: '1.7rem' }}>Post notes &amp; updates on your personal wall.</p>
          <div className="brownroundbutton" onClick={() => { handleGoToWall(); window.scrollTo(0, 0); }} style={{ cursor: 'pointer', margin: 0, width: '100%', boxSizing: 'border-box' }}>
            <span className="brownbuttonlink">My Wall</span>
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.75)', borderRadius: '16px', padding: '20px', width: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <p className="mediumtext" style={{ margin: 0, padding: 0, width: '100%', fontSize: '1.7rem' }}>Read and comment on any Bible chapter.</p>
          <div className="brownroundbutton" style={{ margin: 0, width: '100%', boxSizing: 'border-box' }}>
            <Link className="brownbuttonlink" to="/read" onClick={() => window.scrollTo(0, 0)}>Study the Word</Link>
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.75)', borderRadius: '16px', padding: '20px', width: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <p className="mediumtext" style={{ margin: 0, padding: 0, width: '100%', fontSize: '1.7rem' }}>See who else is studying with you and <b>see their posts</b>!</p>
          <div className="brownroundbutton" style={{ margin: 0, width: '100%', boxSizing: 'border-box' }}>
            <Link className="brownbuttonlink" to="/users" onClick={() => window.scrollTo(0, 0)}>The Community</Link>
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.75)', borderRadius: '16px', padding: '20px', width: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <p className="mediumtext" style={{ margin: 0, padding: 0, width: '100%', fontSize: '1.7rem' }}>Join a loving Biblical discussion with friends.</p>
          <div className="brownroundbutton" style={{ margin: 0, width: '100%', boxSizing: 'border-box' }}>
            <Link className="brownbuttonlink" to="/theforum" onClick={() => window.scrollTo(0, 0)}>The Forum</Link>
          </div>
        </div>

        <div style={{ background: 'rgba(255,255,255,0.75)', borderRadius: '16px', padding: '20px', width: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <p className="mediumtext" style={{ margin: 0, padding: 0, width: '100%', fontSize: '1.7rem' }}>Learn how scripture applies to us today.</p>
          <div className="brownroundbutton" style={{ margin: 0, width: '100%', boxSizing: 'border-box' }}>
            <Link className="brownbuttonlink" to="/videos">Video Teachings</Link>
          </div>
        </div>
      </div>
      </div>
      <h3 className="dashboard-header">Engage With The Latest Posts...</h3>
      <div className="dashboard-data">
        <h4 className="data-header">
          The Most Recent Commentary on Bible Chapters:
        </h4>
        <div>
          {lastCommentary.map((commentary) =>
            users.map((user) => {
              if (user.id === commentary.user_id) {
                return (
                  <div className="roundedbox2" key={commentary.id}>
                    <div className="commentary-text">
                      <img
                        id="smallprofilepic"
                        src={user.profile_pic_url || genericProfilePic}
                        alt={`${user.first_name} ${user.last_name}'s profile`}
                      />
                      <br />
                      <b>
                        {user.first_name} {user.last_name} commented on{" "}
                        {commentary.book} {commentary.chapter}:
                      </b>
                    </div>
                    <p className="commentary-text">{commentary.commentary}</p>
                  </div>
                );
              }
              return null;
            })
          )}
        </div>
        <Link
          to={{ pathname: "/read", hash: "#books" }}
          onClick={() => window.scrollTo(0, 650)}
        >
          <div className="action-button">Go to Bible Books</div>
        </Link>
      </div>

      <div className="dashboard-data-2">
        <h4 className="data-header">The Most Recent Posts in The Forum:</h4>

        {filteredPosts.map((post) =>
          users.map((user) => {
            if (user.id === post.user_id) {
              return (
                <div className="roundedbox" key={post.id}>
                  <div className="commentary-text">
                    <div>
                      <img
                        id="mycommentarypic"
                        src={user.profile_pic_url || genericProfilePic}
                        alt={`${user.first_name} ${user.last_name}'s profile`}
                      />
                    </div>
                    <b>
                      {user.first_name} {user.last_name} posted in{" "}
                      {post.discussion_room}:
                    </b>
                  </div>
                  <EditableText
                    text={post.post}
                    edited={!!post.edited_at}
                    canEdit={post.user_id === userId}
                    canDelete={post.user_id === userId}
                    onSave={async ({ text }) => {
                      await editForumPost(post.id, text);
                      setPosts(prev => prev.map(p => p.id === post.id ? { ...p, post: text, edited_at: new Date() } : p));
                    }}
                    onDelete={async () => {
                      const replyIds = postComments.filter(c => c.post_id === post.id).map(c => c.id);
                      await deleteForumPost(post.id, replyIds);
                      setPosts(prev => prev.filter(p => p.id !== post.id));
                      setPostComments(prev => prev.filter(c => c.post_id !== post.id));
                    }}
                  />
                  {openCommentFor !== post.id ? (
                    <button
                      className="respond-btn"
                      onClick={() => setOpenCommentFor(post.id)}
                    >
                      Respond
                    </button>
                  ) : (
                    <AddComment
                      setViewAddComment={() => setOpenCommentFor(null)}
                      post_id={post.id}
                      discussionroom={post.discussion_room}
                      post_author_id={post.user_id}
                      onCommentPosted={(newComment) =>
                        setPostComments(prev => [...prev, newComment])
                      }
                    />
                  )}

                  <div id="comments">
                    <br />
                    <br />
                    <h4 id="comments-title">Comments</h4>
                    {postComments
                      .filter((comment) => post.id === comment.post_id)
                      .map((comment) =>
                        users.map((commentuser) => {
                          if (commentuser.id === comment.user_id) {
                            return (
                              <div key={comment.id}>
                                <div>
                                  <img
                                    id="smallprofilepic"
                                    src={commentuser.profile_pic_url || genericProfilePic}
                                    alt={`${commentuser.first_name} ${commentuser.last_name}'s profile`}
                                  />
                                </div>
                                <p className="commentary-text">
                                  <b>
                                    {commentuser.first_name}{" "}
                                    {commentuser.last_name} Responded:
                                  </b>
                                </p>
                                <EditableText
                                  text={comment.comment}
                                  edited={!!comment.edited_at}
                                  itemLabel="comment"
                                  canEdit={comment.user_id === userId}
                                  canDelete={comment.user_id === userId || post.user_id === userId}
                                  onSave={async ({ text }) => {
                                    await editForumComment(comment.id, text);
                                    setPostComments(prev => prev.map(c => c.id === comment.id ? { ...c, comment: text, edited_at: new Date() } : c));
                                  }}
                                  onDelete={async () => {
                                    await deleteForumComment(comment.id);
                                    setPostComments(prev => prev.filter(c => c.id !== comment.id));
                                  }}
                                />
                                <br />
                                <br />
                              </div>
                            );
                          }
                          return null;
                        })
                      )}
                  </div>
                </div>
              );
            }
            return null;
          })
        )}
        <Link to="/theforum" onClick={() => window.scrollTo(0, 0)}>
          <div className="action-button">Go to The Forum</div>
        </Link>
      </div>

    </div>
  );
}

export const SET_PROFILE_PIC = "SET_PROFILE_PIC";
export const GET_PROFILE_PIC = "GET_PROFILE_PIC";

const mapStateToProps = (state) => {
  return {
    first_name: state.first_name,
    last_name: state.last_name,
    profile_pic_url: state.profile_pic_url,
    profile_pic_alt: state.profile_pic_alt,
  };
};

export default connect(mapStateToProps, {
  getName,
  uploadProfilePic,
  getProfilePic,
})(Dashboard);
